import React from 'react';
import { Select, MenuItem, FormControl } from '@material-ui/core';

function DropdownSelector({
                              entityRef,
                              selectedEntities,
                              handleChangeEntities,
                              selectedYear,
                              selectedWeek,
                              disabled = false
                          }) {
    const selectedEntity = Object.keys(selectedEntities).find(
        key => selectedEntities[key]
    );

    const weekKey = `${selectedYear}-${selectedWeek < 10 ? '0' + selectedWeek : selectedWeek}`;

    // If disabled (loading), DON'T filter, just show MSC
    let filteredEntities;

    if (disabled) {
        filteredEntities = ['MSC'];  // force MSC while loading
    } else {
        filteredEntities = Object.keys(entityRef).filter(entity => {
            const weeks = entityRef[entity]?.weeks;

            // treat missing/empty weeks as available
            if (!weeks || weeks.length === 0) return true;

            return weeks.includes(weekKey);
        });
    }

    // Default selection logic
    const effectiveValue = (() => {
        if (disabled) return 'MSC';  // force MSC while loading

        if (selectedEntity && filteredEntities.includes(selectedEntity)) {
            return selectedEntity;
        }

        if (filteredEntities.includes('MSC')) {
            return 'MSC';
        }

        return filteredEntities[0] || '';
    })();

    return (
        <FormControl component="fieldset">
            <Select
                value={effectiveValue}
                onChange={handleChangeEntities}
                displayEmpty
                disabled={disabled || filteredEntities.length === 0}
            >
                {filteredEntities.map((entity) => (
                    <MenuItem value={entity} key={entity}>
                        <b>{entityRef[entity]?.category || 'Customer'}</b>:&nbsp;
                        {entityRef[entity]?.disp_name || entity}
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    );
}

export default React.memo(DropdownSelector);